import { Box, Button } from '@dtx-company/shared-components/src'
import { useFormContext } from 'react-hook-form-deprecated'
import React, { useEffect } from 'react'

interface CovidQuestionProps {
  qName: string
  El: React.ReactNode
  advanceStep: () => Promise<void>
  endQuestions: () => Promise<void>
}

const CovidQuestion: React.FC<CovidQuestionProps> = ({ qName, El, advanceStep, endQuestions }) => {
  const { setValue, register } = useFormContext()
  const formKey = 'questions.' + qName
  useEffect(() => {
    register(formKey)
  })

  return (
    <>
      {El}
      <Box justifyContent="space-around" mt={32}>
        <Button
          colorVariant="secondaryBlack"
          sizeVariant="mobileFullWidth"
          mr="16px"
          tabIndex={-1}
          onClick={e => {
            e.preventDefault()
            setValue(formKey, false)
            advanceStep()
          }}
        >
          No
        </Button>
        <Button
          colorVariant="primaryBlack"
          sizeVariant="mobileFullWidth"
          tabIndex={-1}
          onClick={e => {
            e.preventDefault()
            setValue(formKey, true)
            endQuestions()
          }}
        >
          Yes
        </Button>
      </Box>
    </>
  )
}

export default CovidQuestion
